/* eslint-disable jsdoc/check-param-names */
import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty, getLogger } from '@olympeio/core';
import React from 'react';
import { AdvancedSearchInput } from '../shared/AdvancedSearchInput.jsx';
import { AdvancedSearchTemplate } from '../shared/AdvancedSearchTemplate.jsx';
import { AdvancedSearchKey } from '../shared/_enums';
import { AdvancedMasterDataSearchInput } from '../shared/AdvancedMasterDataSearchInput.jsx';

export default class WBSAdvancedSearchPopup extends ReactBrick {
    init($) {
        // as this is an OR filtering, clear the selected values of the other filter
        // this logic is defined in init to avoid being run multiple times (if it would be in render())
        $.set('Selected Approvers', []);
        $.set('Selected PrnByNumber', []);
        $.set('Selected PrnByInternal', []);
        $.set('Selected PrnByWBS', []);
        $.set('Selected Agents', []);
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @returns {React.ReactElement}
     */
    static getReactComponent($) {
        const getOptions = $.get('get options');

        return (props) => {
            const hidden = useProperty($, 'Hidden');
            const approvers = useProperty($, 'Approvers');
            const agents = useProperty($, 'Agents');
            const selectedApprovers = useProperty($, 'Selected Approvers');
            const selectedAgents = useProperty($, 'Selected Agents');
            const prnByNumber = useProperty($, 'PrnByNumber');
            const selectedPrnByNumber = useProperty($, 'Selected PrnByNumber');
            const prnByWbs = useProperty($, 'PrnByWBS');
            const selectedPrnByWbs = useProperty($, 'Selected PrnByWBS');
            const prnByInternal = useProperty($, 'PrnByInternal');
            const selectedPrnByInternal = useProperty($, 'Selected PrnByInternal');
            const isFullScreen = useProperty($, 'Is Full Screen');
            const image = useProperty($, 'Image');
            const cannotApply =
                (selectedApprovers === undefined || selectedApprovers.length === 0) &&
                (selectedAgents === undefined || selectedAgents.length === 0) &&
                (selectedPrnByNumber === undefined || selectedPrnByNumber.length === 0) &&
                (selectedPrnByWbs === undefined || selectedPrnByWbs.length === 0) &&
                (selectedPrnByInternal === undefined || selectedPrnByInternal.length === 0);

            const logger = getLogger('CostCenterAdvancedSearchPopup');

            const handleClose = () => {
                $.trigger('Apply WBS Advanced Search');
                $.set('Hiddent', true);
            };

            const handleClear = () => {
                $.trigger('Clear Approvers');
                $.trigger('Clear PrnByNumber');
                $.trigger('Clear PrnByInternal');
                $.trigger('Clear PrnByWBS');
            };

            const searchFields = (
                <>
                    <AdvancedSearchInput
                        context={$}
                        data={prnByNumber}
                        searchKey={AdvancedSearchKey.PRN_BY_NUMBER}
                        title="Person Responsible ID (PRN)"
                    />
                    <AdvancedSearchInput
                        context={$}
                        data={prnByInternal}
                        searchKey={AdvancedSearchKey.PRN_BY_INTERNAL}
                        title="Internal WBS (for specific markets in AMS and LATAM)"
                        placeholderText="Search By ID"
                    />
                    <AdvancedSearchInput
                        context={$}
                        data={prnByWbs}
                        searchKey={AdvancedSearchKey.PRN_BY_WBS_ELEMENT}
                        title="WBS Elements"
                        placeholderText="Search By ID"
                    />
                    <AdvancedSearchInput context={$} data={approvers} searchKey={AdvancedSearchKey.APPROVER} />
                    <AdvancedMasterDataSearchInput
                        context={$}
                        logger={logger}
                        filter={(value) => `IdNo eq '01' and SearchTerm eq '${value}'`}
                        getOptions={getOptions}
                        data={agents}
                        path={'PositionIdSet'}
                        searchKey={AdvancedSearchKey.AGENT}
                        title={'Position'}
                    />
                </>
            );

            return (
                !hidden && (
                    <AdvancedSearchTemplate
                        image={image}
                        searchFields={searchFields}
                        isFullScreen={isFullScreen}
                        cannotApply={cannotApply}
                        handleClose={handleClose}
                        handleClear={handleClear}
                    />
                )
            );
        };
    }
}

registerBrick('018017c3d7b37d7c49f5', WBSAdvancedSearchPopup);
